export type ShareOutcome = "shared" | "copied" | "aborted";

/** Baixar é o mesmo gesto no estúdio e na galeria; só muda de onde vem o arquivo. */
export function downloadFile(file: File) {
  const url = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.name;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/**
 * Compartilhar tem três desfechos e nenhum deles é erro: mandar o arquivo, mandar só o
 * link (navegador sem suporte a arquivo) e desistir. Fechar a folha de compartilhamento
 * levanta AbortError, e tratá-lo como falha faria o app acusar um erro que não houve.
 */
export async function shareFile(file: File, data: ShareData): Promise<ShareOutcome> {
  try {
    if (navigator.canShare?.({ files: [file] })) {
      await navigator.share({ ...data, files: [file] });
    } else if (navigator.share) {
      await navigator.share(data);
    } else {
      await navigator.clipboard.writeText(`${data.text || ""} ${data.url || ""}`.trim());
      return "copied";
    }
    return "shared";
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") return "aborted";
    throw error;
  }
}
